//Creates tooltip and makes it invisiblae
var div = d3.select(".gia-chart").append("div")
    .attr("class", "tooltip")
    .style("opacity", 0);

//Sets dimensions
var margin = {top: 0, left: 5, bottom: 5, right: 5},
  width = d3.select(".gia-chart").node().clientWidth,
  width = width - margin.left - margin.right,
  mapRatio = .65,
  height = width * mapRatio;

//Tells the map what projection to use
var projection = d3.geo.albersUsa()
  .scale(width *1.25)
  .translate([width / 2, height / 2]);

//Tells the map how to draw the paths from the projection
var path = d3.geo.path()
  .projection(projection);


//Appened svg to page
var map = d3.select(".gia-chart").append("svg")
  .style('height', height + 'px')
  .style('width', width + 'px');  

//Load the files
queue()
  .defer(d3.json, "data/usmap.json")
  .defer(d3.csv, "data/states.csv")
  .await(ready);

//Moves selection to front
d3.selection.prototype.moveToFront = function() {
  return this.each(function(){
    this.parentNode.appendChild(this);
  });
}; 

//Moves selection to back
d3.selection.prototype.moveToBack = function() { 
  return this.each(function() { 
    var firstChild = this.parentNode.firstChild; 
      if (firstChild) { 
        this.parentNode.insertBefore(this, firstChild); 
      } 
    }); 
  }; 

function ready(error, us, maptemplate) {
  if (error) throw error;  
 
  //Pair data with state id
  var dataByFIPS = {};
  maptemplate.forEach(function(d) { dataByFIPS[d.FIPS] = d.num; });

  //Pair state name with state id
  var stateByFIPS = {};
  maptemplate.forEach(function(d) { stateByFIPS[d.FIPS] = d.state; });

  //Append states
  map.append("g")
    .attr("class", "states")
    .selectAll("path")
    .data(topojson.feature(us, us.objects.states).features)
    .enter().append("path")
    .attr("d", path)
    .style("fill", function(d) { 
      if(dataByFIPS[d.id] > 0 && dataByFIPS[d.id] <=2) {
        return "#e6f5fa"
      }
      else if(dataByFIPS[d.id] > 2 && dataByFIPS[d.id] <=4) {
        return "#cdecf4"
      }
      else if(dataByFIPS[d.id] > 4 && dataByFIPS[d.id] <=6) {
        return "#b1e2ef"
      }
      else if(dataByFIPS[d.id] > 6 && dataByFIPS[d.id] <=8) {
        return "#95d9ea"
      }
      else if(dataByFIPS[d.id] > 8 && dataByFIPS[d.id] <=10) {
        return "#74d0e4"
      }
      else if(dataByFIPS[d.id] > 10){
        return "#4bc6df"
      }
      else {
        return "#eaeaea"
      }
    });

    //Append percentages
    var labels = map.append("g")
      .attr("class", "states-data")
      .selectAll("text")
      .data(topojson.feature(us, us.objects.states).features)
      .enter()
      .append("svg:text")
      .text(function(d){
        if (dataByFIPS[d.id] > 0 ) {
          return dataByFIPS[d.id];
        }
        else {
          return null
        }
       })
      //.attr("transform", function(d) {
        //var centerLabel = path.centroid(d);
      //}
      .attr("x", function(d){
        return path.centroid(d)[0];
      })
      .attr("y", function(d){
        return  path.centroid(d)[1] + 3;
      })
      .attr("text-anchor","middle");


  //RESPONSIVENESS
  d3.select(window).on('resize', resize);

  function resize() {

    var w = d3.select(".gia-chart").node().clientWidth;

    //Adjust things when the window size changes
    width = w - margin.left - margin.right;
    height = width * mapRatio;
    
    //Update projection
    var newProjection = d3.geo.albersUsa()
      .scale(width*1.25)
      .translate([width / 2, height / 2]);

    //Update path
    path = d3.geo.path()
      .projection(newProjection);    

    //Resize the map container
    map
      .style('width', width + 'px')
      .style('height', height + 'px');

    //Resize the map
    map.selectAll("path").attr('d', path);

    labels
     .attr("x", function(d){
        return path.centroid(d)[0];
      })
      .attr("y", function(d){
        return  path.centroid(d)[1] + 3;
      })
 
  }
}